import * as schemaCompanies from "~/schemas/schema.companies";
import {
  ADD_COMPANY,
  LOAD_COMPANY,
  LOAD_COMPANIES,
  LOAD_REQUEST,
  LOAD_FAILURE,
  ARCHIVE_COMPANY_LOADING,
  ARCHIVE_COMPANY_SUCCESS,
  ARCHIVE_COMPANY_ERROR,
  EDIT_COMPANY_LOADING,
  EDIT_COMPANY_SUCCESS,
  EDIT_COMPANY_ERROR,
} from "~/store/action_types";
import * as actionTypes from "~/store/action_types";
import * as trashActions from "~/store/actions/actions.trash";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const addCompany = (attributes) => {
  return {
    types: [LOAD_REQUEST, ADD_COMPANY, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/companies`,
        method: "post",
        body: attributes,
      }),
    payload: { attributes },
  };
};

export const editCompany = (company_id, attributes) => {
  return {
    types: [EDIT_COMPANY_LOADING, EDIT_COMPANY_SUCCESS, EDIT_COMPANY_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/companies/${company_id}`,
        method: "put",
        body: attributes,
      }),
    payload: { company_id, attributes },
  };
};

export const loadCompany = (company_id) => {
  return {
    types: [LOAD_REQUEST, LOAD_COMPANY, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/companies/${company_id}`,
      }),
    payload: { company_id },
  };
};

export const loadCompanies = () => {
  return {
    types: [LOAD_REQUEST, LOAD_COMPANIES, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/companies`,
      }),
  };
};

export const loadAllCompanies = () => {
  return {
    types: [LOAD_REQUEST, LOAD_COMPANIES, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/companies/all`,
      }),
  };
};

export const loadArchiveCompanies = () => {
  return {
    types: [LOAD_REQUEST, LOAD_COMPANIES, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/companies/archive`,
      }),
  };
};

export const archiveCompany = (company_id) => {
  return {
    types: [ARCHIVE_COMPANY_LOADING, ARCHIVE_COMPANY_SUCCESS, ARCHIVE_COMPANY_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/move-to-archive/company/${company_id}`,
        method: "put",
      }),
  };
};

export const moveToTrash = (id, trashTracking = false) => {
  const objectType = `Company`;
  return {
    ...trashActions.moveToTrash(objectType, id, {
      trash_tracking: trashTracking,
    }),
    types: [
      actionTypes.MOVE_COMPANY_TO_TRASH_LOADING,
      actionTypes.MOVE_COMPANY_TO_TRASH_SUCCESS,
      actionTypes.MOVE_COMPANY_TO_TRASH_ERROR,
    ],
  };
};

export const companyCreatedFromEventStream = (data) => {
  return {
    type: actionTypes.ADD_COMPANY_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaCompanies.company,
  };
};

export const companyUpdatedFromEventStream = (data) => {
  return {
    type: actionTypes.EDIT_COMPANY_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaCompanies.company,
    id: data.id,
  };
};

export const companyMovedToTrashFromEventStream = (data) => {
  return {
    type: actionTypes.COMPANY_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaCompanies.company,
    id: data.id,
  };
};

export const companyRestoredFromTrashFromEventStream = (data) => {
  return {
    type: actionTypes.COMPANY_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaCompanies.company,
    id: data.id,
  };
};

export const companyMovedToArchiveFromEventStream = (data) => {
  return {
    type: actionTypes.MOVE_COMPANY_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaCompanies.company,
    id: data.id,
  };
};

export const companyRestoredFromArchiveFromEventStream = (data) => {
  return {
    type: actionTypes.RESTORE_COMPANY_FROM_ARCHIVE_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaCompanies.company,
    id: data.id,
  };
};
